export default "__VITE_ASSET__BgePVixk__"